'use client';
import {
  Box,
  Table,
  TableContainer,
  type TableContainerProps,
  type TableProps,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';

type Props = {
  children: React.ReactNode;
  tableProps?: TableProps;
  tableContainerProps?: TableContainerProps;
};

export default function SummaryTableContainer({
  children,
  tableProps,
  tableContainerProps,
}: Props) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [showFade, setShowFade] = useState({ left: false, right: false });

  useEffect(() => {
    const contentElement = contentRef.current;

    const handleScroll = () => {
      setShowFade({
        left: (contentElement?.scrollLeft || 0) > 0,
        right:
          (contentElement?.scrollLeft || 0) <
          (contentElement?.scrollWidth || 0) - (contentElement?.clientWidth || 0),
      });
    };

    handleScroll();

    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
    }

    return () => {
      if (contentElement) {
        contentElement.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
      }
    };
  }, []);
  return (
    <Box sx={{ position: 'relative', maxWidth: '1280px' }}>
      <TableContainer
        ref={contentRef}
        {...tableContainerProps}
        sx={({ breakpoints }) => ({
          overflowX: { xs: 'auto', md: 'hidden' },
          overflowY: 'hidden',
          width: '100%',
          position: 'relative',
          [breakpoints.down('md')]: {
            '--fade':
              showFade.left && showFade.right
                ? `linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.7) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 0.7) 95%, transparent 100%)`
                : !showFade.left && showFade.right
                  ? 'linear-gradient(to left, transparent, black 5%)'
                  : showFade.left && !showFade.right
                    ? 'linear-gradient(to right, transparent, black 5%)'
                    : 'none',
            maskImage: 'var(--fade) !important',
            WebkitMaskImage: 'var(--fade)',
          },
        })}
      >
        <Table
          {...tableProps}
          sx={({ breakpoints }) => ({
            border: 0,
            [breakpoints.up('md')]: {
              minWidth: 775,
            },
          })}
        >
          {children}
        </Table>
      </TableContainer>
    </Box>
  );
}
